import { render, staticRenderFns } from "./CertificateNew.vue?vue&type=template&id=623bf36c&scoped=true&"
import script from "./CertificateNew.vue?vue&type=script&lang=js&"
export * from "./CertificateNew.vue?vue&type=script&lang=js&"
import style0 from "./CertificateNew.vue?vue&type=style&index=0&id=623bf36c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623bf36c",
  null
  
)

export default component.exports